import LoadingButtonProvider from '@/components/buttons/LoadingButtonProvider';
import { QuickLoginModalHOC } from '@/components/modal/LoginModal2HOC';
import { ROLE_ACCESS, TRoleAccess } from '@/constant/storage';
import usePostGroupRole from '@/hooks/post/usePostGroupRole';
import useToast from '@/hooks/useToast';
import { deleteCancelRequestJoinGroup, postJoinGroup } from 'apis/tms/feed.api';
import { AxiosError } from 'axios';
import { checkIsUserJoined } from 'common/checkRoleUser';
import { PostContext } from 'context/PostContext';
import { Button } from 'design-system/components/Button';
import { useContext } from 'react';
import { useMutation } from 'react-query';
import AuthContext from 'state/auth/AuthContext';

const NewPostHeadJoinGroupBtnMutate = ({
  userRole,
  refetch,
}: {
  refetch: () => void;
  userRole: TRoleAccess;
}) => {
  const { group } = useContext(PostContext);
  const { isLoggedIn } = useContext(AuthContext);
  const toast = useToast();

  const asyncFunction = async (isJoin: boolean) => {
    isJoin
      ? await deleteCancelRequestJoinGroup(group!.groupId)
      : await postJoinGroup(group!.groupId, group?.status);
  };

  const { mutate, isLoading: mutationLoading } = useMutation<
    void,
    AxiosError,
    boolean
  >((_prop) => asyncFunction(_prop), {
    onSuccess() {
      refetch();
      toast(
        `Bạn đã ${
          userRole === ROLE_ACCESS.Requested ? 'hủy' : 'gửi'
        } yêu cầu tham gia nhóm`,
        'success'
      );
    },
    onError(err) {
      if (!isLoggedIn()) {
        return;
      }
      if (err?.response?.status !== 400) {
        toast('Có lỗi xảy ra, vui lòng thử lại', 'error');
      }
    },
  });

  return (
    <QuickLoginModalHOC
      handleClickWhenDisabledQuickLogin={() =>
        mutate(userRole === ROLE_ACCESS.Requested)
      }
      loginSuccessCb={() => {
        mutate(userRole === ROLE_ACCESS.Requested);
      }}
    >
      <LoadingButtonProvider
        className="flex-shrink-0 rounded-full"
        isLoading={mutationLoading}
      >
        <Button emphasis="medium" size="medium">
          {userRole === 'Requested' ? 'Đã gửi yêu cầu' : 'Tham gia'}
        </Button>
      </LoadingButtonProvider>
    </QuickLoginModalHOC>
  );
};

const NewPostHeadJoinGroupBtn = () => {
  const { group, postId } = useContext(PostContext);

  const { data: userRole, refetch } = usePostGroupRole({
    groupId: group?.groupId,
    postId,
  });

  return !checkIsUserJoined(userRole as ROLE_ACCESS) ? (
    <NewPostHeadJoinGroupBtnMutate refetch={refetch} userRole={userRole} />
  ) : null;
};

export default NewPostHeadJoinGroupBtn;
